import type { BlueprintBoxComponent } from '@/grove-blueprints/generated-types'

type BoxAlignment = NonNullable<
  NonNullable<BlueprintBoxComponent['props']>['alignment']
>

const BOX_ALIGNMENT_CLASS: Record<BoxAlignment, string> = {
  topLeading: 'items-start justify-items-start',
  top: 'items-start justify-items-center',
  topTrailing: 'items-start justify-items-end',
  leading: 'items-center justify-items-start',
  center: 'items-center justify-items-center',
  trailing: 'items-center justify-items-end',
  bottomLeading: 'items-end justify-items-start',
  bottom: 'items-end justify-items-center',
  bottomTrailing: 'items-end justify-items-end',
}

export function resolveBoxAlignment(
  alignment: BoxAlignment | undefined,
): string {
  if (alignment === undefined) {
    return ''
  }

  return BOX_ALIGNMENT_CLASS[alignment]
}
